import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { BackHeader } from "@/components/TopBar";
import { Spinner, EmptyState } from "@/components/common";
import { Bell, Heart, MessageCircle, Users, Sparkles } from "lucide-react";

const ICONS = { interest: Heart, message: MessageCircle, tribe: Users, match: Sparkles };

export default function Notifications() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  const load = () => api.get("/notifications").then((r) => setItems(r.data.items)).catch(() => setItems([]));
  useEffect(() => { load(); api.post("/notifications/read-all").catch(() => {}); }, []);

  const open = (n) => {
    if (n.meta?.conversation_id) navigate(`/chat/${n.meta.conversation_id}`);
    else if (n.meta?.from_id) navigate(`/person/${n.meta.from_id}`);
    else if (n.meta?.tribe_id) navigate(`/tribe/${n.meta.tribe_id}`);
  };

  return (
    <div>
      <BackHeader title="Notifications" />
      <div className="px-4 pt-4">
        {items === null ? <Spinner /> : items.length ? (
          <div className="space-y-2">
            {items.map((n) => {
              const Icon = ICONS[n.type] || Bell;
              return (
                <div key={n.notification_id} data-testid={`notif-${n.notification_id}`} onClick={() => open(n)} className={`flex cursor-pointer items-start gap-3 rounded-3xl p-4 shadow-soft ${n.read ? "bg-white" : "bg-brand-light"}`}>
                  <div className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-brand text-white"><Icon className="h-5 w-5" /></div>
                  <div className="flex-1"><h4 className="font-heading font-bold text-ink">{n.title}</h4><p className="text-sm text-ink-soft">{n.body}</p></div>
                </div>
              );
            })}
          </div>
        ) : <EmptyState icon={Bell} title="No notifications yet" sub="Matches, messages and interest will show up here." />}
      </div>
    </div>
  );
}
